import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { MdOutlineErrorOutline } from 'react-icons/md';
import { cn } from '../../utils';
/**
 * Displays a generic error state with a header and error message.
 */
export function ErrorDisplay({ className, header, error, actions, }) {
    return (_jsx("div", { className: cn('flex h-full items-center justify-center', className), children: _jsxs("div", { className: "flex max-w-xl flex-col items-center space-y-4 text-center", children: [_jsx("div", { children: _jsx(MdOutlineErrorOutline, { className: "size-20 text-muted-foreground" }) }), _jsx("h1", { children: header ?? 'Sorry, something went wrong' }), _jsx("p", { children: typeof error === 'string' || React.isValidElement(error)
                        ? error
                        : 'We encountered an error showing this page.' }), actions] }) }));
}
//# sourceMappingURL=ErrorDisplay.js.map